// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Main Layout Styles - Dark theme
 */

:root {
  /* Alto de la barra superior. Es TAMBIÉN el alto del bloque de marca del
     sidebar (\`.sidebar-brand\`), que ya no está dentro del área con scroll y
     arranca en la misma y (0). Así las dos líneas inferiores coinciden exactas
     de lado a lado: 16 (padding) + 36 (icono) + 16 + 1 (borde) = 69px. */
  --app-topbar-h: 69px;

  /* Alto de la barra de ruta de navegación (breadcrumbs). Los overlays de
     detalle arrancan por debajo: top = topbar + crumb bar (ver DetailView.css). */
  --app-crumb-h: 42px;
}

.main-layout {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  background-color: var(--slate-50);
  overflow: hidden;
}

/* Los diseñadores ocupan TODO el alto real del viewport: \`styles/app.css\` fija
   \`.main-layout { height: calc(100vh - 64px) }\`, que dejaba una franja muerta
   abajo (el alto de la barra superior otra vez). */
.main-layout.is-canvas {
  height: 100vh;
  height: 100dvh;
}

/* Los diseñadores ocupan TODO el alto real del viewport: \`styles/app.css\` fija
   \`.main-layout { height: calc(100vh - 64px) }\` y dejaba una franja muerta
   abajo (la altura de la barra superior otra vez). */
.main-layout.is-canvas {
  height: 100vh;
  height: 100dvh;
}

/* Layout Container (Sidebar + Content) */
.layout-container {
  display: flex;
  flex: 1 1;
  position: relative;
  padding-top: 0;
  padding-left: 240px;
  overflow: hidden;
  width: 100%;
}

/* Main Content Area */
.main-content {
  flex: 1 1;
  padding: 2rem;
  transition: all 0.3s ease;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  background: var(--slate-50);
  /* OJO: SIN z-index. Un \`z-index\` aquí crea un contexto de apilado que atrapa
     los modales/overlays \`position: fixed\` del contenido POR DEBAJO del sidebar
     (1100) y la barra superior (1030): el modal parece empezar a la derecha del
     menú. Sin z-index, \`position: relative\` no genera contexto y los \`fixed\`
     vuelven a resolver contra la raíz (su z-index ya los pone encima). */
  position: relative;
}

.content-wrapper {
  max-width: 1400px;
  margin: 0 auto;
}

/* ── Diseñadores a sangre (cableado / switches) ────────────────────────────
   El lienzo necesita el máximo espacio: sin relleno del layout, sin el tope de
   1400 px y con el alto del main-content (no un calc() del viewport).
   OJO: los skins (styles/skins.css) fijan \`html[data-skin-base] .main-content
   { padding: 2.25rem … }\`, que gana por especificidad: se replica el selector. */
.main-content.is-canvas,
html[data-skin-base] .main-content.is-canvas {
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.main-content.is-canvas .content-wrapper.is-canvas {
  max-width: none;
  margin: 0;
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.main-content.is-canvas .content-wrapper.is-canvas > * {
  flex: 1 1;
  min-height: 0;
}
/* El diseñador deja de calcular su alto contra el viewport: lo hereda.
   (Se excluye la pantalla completa: ahí manda \`.swd-page:fullscreen\`.) */
.main-content.is-canvas .swd-page:not(:fullscreen):not(.is-fullscreen),
.main-content.is-canvas .swd-page.is-tabbed:not(:fullscreen):not(.is-fullscreen) {
  height: auto;
  min-height: 0;
  flex: 1 1;
}
@media (max-height: 820px) {
  .main-content.is-canvas { padding: 0; }
}
@media (max-width: 768px) {
  .main-content.is-canvas { padding: 0; }
}
@media (max-width: 576px) {
  .main-content.is-canvas { padding: 0; }
}

/* Session expired banner */
.session-expired-banner {
  background: rgba(245,158,11,.12);
  color: #fcd34d;
  border: 1px solid rgba(245,158,11,.25);
  border-radius: 10px;
  padding: 10px 18px;
  margin: 12px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  font-size: 0.9rem;
}

/* Mobile Responsive */
@media (max-width: 992px) {
  .layout-container { padding-left: 0; }
  .main-content { padding: 1.5rem; }
}

/* Portátiles bajos (14" a 1366×768 y, con escalado, aún menos): el aire de
   arriba se paga en filas de tabla que no se ven. Se recorta el relleno. */
@media (max-height: 820px) {
  .main-content { padding: 1rem 1.5rem; }
}

@media (max-width: 768px) {
  .main-content { padding: 1rem; }
}

@media (max-width: 576px) {
  .main-content { padding: 0.75rem; }
}

@media print {
  .main-content { margin-left: 0; padding: 0; }
}

html { scroll-behavior: smooth; }

.quick-feedback-form {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.quick-feedback-label {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.84rem;
  color: var(--text-secondary);
  font-weight: 600;
}

.quick-feedback-input,
.quick-feedback-textarea {
  width: 100%;
  border: 1px solid var(--border);
  background: var(--bg-input);
  color: var(--text-primary);
  border-radius: 8px;
  padding: 0.55rem 0.7rem;
  font-size: 0.9rem;
  outline: none;
}

.quick-feedback-input:focus,
.quick-feedback-textarea:focus {
  border-color: rgba(var(--accent-rgb), 0.45);
  box-shadow: 0 0 0 2px rgba(var(--accent-rgb), 0.12);
}

.quick-feedback-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem;
}

/* Nota del autor del ticket: quien abre el feedback queda registrado por el
   servidor, y se dice aqui para que no haya duda de a nombre de quien va. */
.quick-feedback-hint {
  margin: 0;
  font-size: 0.82rem;
  color: var(--text-secondary);
}

.quick-feedback-error,
.quick-feedback-success {
  border-radius: 8px;
  padding: 0.55rem 0.7rem;
  font-size: 0.84rem;
}

.quick-feedback-error {
  border: 1px solid rgba(239, 68, 68, 0.3);
  background: rgba(239, 68, 68, 0.14);
  color: #fecaca;
}

.quick-feedback-success {
  border: 1px solid rgba(16, 185, 129, 0.3);
  background: rgba(16, 185, 129, 0.14);
  color: #a7f3d0;
}

.quick-feedback-primary,
.quick-feedback-secondary {
  border-radius: 8px;
  border: 1px solid var(--border);
  padding: 0.48rem 0.85rem;
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
}

.quick-feedback-secondary {
  background: var(--bg-toolbar);
  color: var(--text-secondary);
}

.quick-feedback-secondary:hover {
  border-color: rgba(var(--accent-rgb), 0.3);
  color: var(--text-primary);
}

.quick-feedback-primary {
  background: rgba(var(--accent-rgb), 0.9);
  border-color: rgba(var(--accent-rgb), 0.95);
  color: #fff;
}

.quick-feedback-primary:hover {
  filter: brightness(1.05);
}

.quick-feedback-primary:disabled,
.quick-feedback-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 680px) {
  .quick-feedback-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MainLayout.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE;;;yEAGuE;EACvE,oBAAoB;;EAEpB;kFACgF;EAChF,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,cAAc;EACd,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;;mDAEmD;AACnD;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;qDAEqD;AACrD;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,SAAO;EACP,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B;;;;yEAIuE;EACvE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;iFAIiF;AACjF;;EAEE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,SAAS;EACT,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,SAAO;EACP,aAAa;AACf;AACA;yEACyE;AACzE;;EAEE,YAAY;EACZ,aAAa;EACb,SAAO;AACT;AACA;EACE,0BAA0B,UAAU,EAAE;AACxC;AACA;EACE,0BAA0B,UAAU,EAAE;AACxC;AACA;EACE,0BAA0B,UAAU,EAAE;AACxC;;AAEA,2BAA2B;AAC3B;EACE,gCAAgC;EAChC,cAAc;EACd,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,oBAAoB,eAAe,EAAE;EACrC,gBAAgB,eAAe,EAAE;AACnC;;AAEA;2EAC2E;AAC3E;EACE,gBAAgB,oBAAoB,EAAE;AACxC;;AAEA;EACE,gBAAgB,aAAa,EAAE;AACjC;;AAEA;EACE,gBAAgB,gBAAgB,EAAE;AACpC;;AAEA;EACE,gBAAgB,cAAc,EAAE,UAAU,EAAE;AAC9C;;AAEA,OAAO,uBAAuB,EAAE;;AAEhC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;AACf;;AAEA;;EAEE,2CAA2C;EAC3C,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;4EAC4E;AAC5E;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/**\r\n * Main Layout Styles - Dark theme\r\n */\r\n\r\n:root {\r\n  /* Alto de la barra superior. Es TAMBIÉN el alto del bloque de marca del\r\n     sidebar (`.sidebar-brand`), que ya no está dentro del área con scroll y\r\n     arranca en la misma y (0). Así las dos líneas inferiores coinciden exactas\r\n     de lado a lado: 16 (padding) + 36 (icono) + 16 + 1 (borde) = 69px. */\r\n  --app-topbar-h: 69px;\r\n\r\n  /* Alto de la barra de ruta de navegación (breadcrumbs). Los overlays de\r\n     detalle arrancan por debajo: top = topbar + crumb bar (ver DetailView.css). */\r\n  --app-crumb-h: 42px;\r\n}\r\n\r\n.main-layout {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  height: 100vh;\r\n  height: 100dvh;\r\n  background-color: var(--slate-50);\r\n  overflow: hidden;\r\n}\r\n\r\n/* Los diseñadores ocupan TODO el alto real del viewport: `styles/app.css` fija\r\n   `.main-layout { height: calc(100vh - 64px) }`, que dejaba una franja muerta\r\n   abajo (el alto de la barra superior otra vez). */\r\n.main-layout.is-canvas {\r\n  height: 100vh;\r\n  height: 100dvh;\r\n}\r\n\r\n/* Los diseñadores ocupan TODO el alto real del viewport: `styles/app.css` fija\r\n   `.main-layout { height: calc(100vh - 64px) }` y dejaba una franja muerta\r\n   abajo (la altura de la barra superior otra vez). */\r\n.main-layout.is-canvas {\r\n  height: 100vh;\r\n  height: 100dvh;\r\n}\r\n\r\n/* Layout Container (Sidebar + Content) */\r\n.layout-container {\r\n  display: flex;\r\n  flex: 1;\r\n  position: relative;\r\n  padding-top: 0;\r\n  padding-left: 240px;\r\n  overflow: hidden;\r\n  width: 100%;\r\n}\r\n\r\n/* Main Content Area */\r\n.main-content {\r\n  flex: 1;\r\n  padding: 2rem;\r\n  transition: all 0.3s ease;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  width: 100%;\r\n  background: var(--slate-50);\r\n  /* OJO: SIN z-index. Un `z-index` aquí crea un contexto de apilado que atrapa\r\n     los modales/overlays `position: fixed` del contenido POR DEBAJO del sidebar\r\n     (1100) y la barra superior (1030): el modal parece empezar a la derecha del\r\n     menú. Sin z-index, `position: relative` no genera contexto y los `fixed`\r\n     vuelven a resolver contra la raíz (su z-index ya los pone encima). */\r\n  position: relative;\r\n}\r\n\r\n.content-wrapper {\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n}\r\n\r\n/* ── Diseñadores a sangre (cableado / switches) ────────────────────────────\r\n   El lienzo necesita el máximo espacio: sin relleno del layout, sin el tope de\r\n   1400 px y con el alto del main-content (no un calc() del viewport).\r\n   OJO: los skins (styles/skins.css) fijan `html[data-skin-base] .main-content\r\n   { padding: 2.25rem … }`, que gana por especificidad: se replica el selector. */\r\n.main-content.is-canvas,\r\nhtml[data-skin-base] .main-content.is-canvas {\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n.main-content.is-canvas .content-wrapper.is-canvas {\r\n  max-width: none;\r\n  margin: 0;\r\n  flex: 1;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.main-content.is-canvas .content-wrapper.is-canvas > * {\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n/* El diseñador deja de calcular su alto contra el viewport: lo hereda.\r\n   (Se excluye la pantalla completa: ahí manda `.swd-page:fullscreen`.) */\r\n.main-content.is-canvas .swd-page:not(:fullscreen):not(.is-fullscreen),\r\n.main-content.is-canvas .swd-page.is-tabbed:not(:fullscreen):not(.is-fullscreen) {\r\n  height: auto;\r\n  min-height: 0;\r\n  flex: 1;\r\n}\r\n@media (max-height: 820px) {\r\n  .main-content.is-canvas { padding: 0; }\r\n}\r\n@media (max-width: 768px) {\r\n  .main-content.is-canvas { padding: 0; }\r\n}\r\n@media (max-width: 576px) {\r\n  .main-content.is-canvas { padding: 0; }\r\n}\r\n\r\n/* Session expired banner */\r\n.session-expired-banner {\r\n  background: rgba(245,158,11,.12);\r\n  color: #fcd34d;\r\n  border: 1px solid rgba(245,158,11,.25);\r\n  border-radius: 10px;\r\n  padding: 10px 18px;\r\n  margin: 12px 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  font-weight: 500;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* Mobile Responsive */\r\n@media (max-width: 992px) {\r\n  .layout-container { padding-left: 0; }\r\n  .main-content { padding: 1.5rem; }\r\n}\r\n\r\n/* Portátiles bajos (14\" a 1366×768 y, con escalado, aún menos): el aire de\r\n   arriba se paga en filas de tabla que no se ven. Se recorta el relleno. */\r\n@media (max-height: 820px) {\r\n  .main-content { padding: 1rem 1.5rem; }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .main-content { padding: 1rem; }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .main-content { padding: 0.75rem; }\r\n}\r\n\r\n@media print {\r\n  .main-content { margin-left: 0; padding: 0; }\r\n}\r\n\r\nhtml { scroll-behavior: smooth; }\r\n\r\n.quick-feedback-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.8rem;\r\n}\r\n\r\n.quick-feedback-label {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.35rem;\r\n  font-size: 0.84rem;\r\n  color: var(--text-secondary);\r\n  font-weight: 600;\r\n}\r\n\r\n.quick-feedback-input,\r\n.quick-feedback-textarea {\r\n  width: 100%;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-input);\r\n  color: var(--text-primary);\r\n  border-radius: 8px;\r\n  padding: 0.55rem 0.7rem;\r\n  font-size: 0.9rem;\r\n  outline: none;\r\n}\r\n\r\n.quick-feedback-input:focus,\r\n.quick-feedback-textarea:focus {\r\n  border-color: rgba(var(--accent-rgb), 0.45);\r\n  box-shadow: 0 0 0 2px rgba(var(--accent-rgb), 0.12);\r\n}\r\n\r\n.quick-feedback-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 0.65rem;\r\n}\r\n\r\n/* Nota del autor del ticket: quien abre el feedback queda registrado por el\r\n   servidor, y se dice aqui para que no haya duda de a nombre de quien va. */\r\n.quick-feedback-hint {\r\n  margin: 0;\r\n  font-size: 0.82rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.quick-feedback-error,\r\n.quick-feedback-success {\r\n  border-radius: 8px;\r\n  padding: 0.55rem 0.7rem;\r\n  font-size: 0.84rem;\r\n}\r\n\r\n.quick-feedback-error {\r\n  border: 1px solid rgba(239, 68, 68, 0.3);\r\n  background: rgba(239, 68, 68, 0.14);\r\n  color: #fecaca;\r\n}\r\n\r\n.quick-feedback-success {\r\n  border: 1px solid rgba(16, 185, 129, 0.3);\r\n  background: rgba(16, 185, 129, 0.14);\r\n  color: #a7f3d0;\r\n}\r\n\r\n.quick-feedback-primary,\r\n.quick-feedback-secondary {\r\n  border-radius: 8px;\r\n  border: 1px solid var(--border);\r\n  padding: 0.48rem 0.85rem;\r\n  font-size: 0.84rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n.quick-feedback-secondary {\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.quick-feedback-secondary:hover {\r\n  border-color: rgba(var(--accent-rgb), 0.3);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.quick-feedback-primary {\r\n  background: rgba(var(--accent-rgb), 0.9);\r\n  border-color: rgba(var(--accent-rgb), 0.95);\r\n  color: #fff;\r\n}\r\n\r\n.quick-feedback-primary:hover {\r\n  filter: brightness(1.05);\r\n}\r\n\r\n.quick-feedback-primary:disabled,\r\n.quick-feedback-secondary:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n@media (max-width: 680px) {\r\n  .quick-feedback-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
